<template>
  <div id="center" class="clearfix" style="min-height: 246px">
    <div id="left-menu" class="pull-left">
      <i class="iconfont m-show-btn mhide"></i>

      <div class="menu-wrap">
        <i class="iconfont close-leftmenu-btns mhide"></i>
        <div class="t-user t-teacher-box">
            <img
            :src="this.$store.state.headPortrait"
            onerror="this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAE90lEQVRogdWbTWgdVRTHf3PfVxbWCFahRoTulFJELRVLrc8aFy5trYW6luLHtttSu5SCC7Eu3IpiStuVaBfamlaCUkF4dmtBqmIwJa2FfMybuS5O7nSSzJt5M/fMS/KDLPLevHPPf+73OfcGCwsL1MQ48AKwB9gF7AQmgIeAB1aeuQfMA38BvwM3gOvADHCnDqcCZcGPA0eBQ8DzQKOinQj4CbgAnAP+UPEOPcEHgBPAa1QXOYgI+AY4A/zga8xXcBc4Dbzo68iQXAVOAleqGjAVf7cD+By4zOjEslLW5ZWyd1QxUKWGjwCfIYPSRnIHeBvp40NTpobbwMfAFBsvFsSHKcSnzrA/GraGtwEXgVcquVY/08DrwO2iB4ep4UeQfrNZxYLMEt8jvuZSJHgc+BZ4TsGpunkauERBd8sT3EYm/mcVnaqbZxCf24MeyBP8EXBQ26MRcBDxPZNBg9YRZATcyhwlQ0OW4AngN2SRr0Icx8mftRZrrRQeBAAYYwiCgEajkXymwDywG7iV/jBL8AVkiC9NFEWJKEda4DAYY2g0GjQaKkvyi8hGJmGt4JeR4b0Si4uLVX+6DmMMrVZLo8Ynge8Su2u+PO1jWbE5Escxy8vLpVrHAE6l/0kLPgDs97GsKRikOyiI3o9oA1YLPuFjNQxD4jj2MZGJtZZ+v+9rJtHm+vCjwJ9As4o11/zqpNPp+LSgPjL7zLoaPkZFsUAtNatcRhPRmDTpw74O1Y3CSz0M0qTHgTk8YlFhGBJFka9DuRhjaLcHLpGHIQIeNsA+PANv2qNzTWU0gH2GLbIbUnqpewyy3vRii9QwwC6DZAS82EKCdxrgMV8rCsu/QpSmvgmD5zYwjmPCMNRwJpd+v68h+kHD/cTWpkehJW2rmnnYEBT68bJBUpYb6cQouWeQUEhlRinYGO8G+Z9BktEb7cioyvjHADd9rTSbzVprOggCms3Km7k0Nw0SofTCGEOn06mlppVt3zDALxqWAK1I4yqUX+J1le1hmqWlJdWVl2ekI00EbDdIYnlGwyJAq9XSMqUVpnXMAPOuvZzXsuo26r6ONptN7S5yHpSCeFlYa4miqHTE0Y3IymLXBfFmkdyqGs7xsbGxoWs7CAI6nU4dg98lROOquPSH2qVsIhJtacHTwLU6SitTwzVwDdEGrM8tndIsyVpbKiPh9tbKce4P0v+opksdURQlqdOquHyxZ864MF0KckC0R8lISBzHiVBtXM7YJc6HJDMhnjUN3QKOA1/lWUsnv+tOtbjTAyA1b4xJXkIOx1kjFvIPpp0F3kl/4ObWKIpGErgrwjX7jJ3Up8C7mb/JEdxG5q8u3B9QNoPQtQRBQKvVchuNaeBVIDOdmbcVWQbeAHqK2fhacInzOI57yCA1MHdbtPeas9ZOhmH4q6qH9dALw3DSWjuX91DhZrPf789aa19CzltuVq4CXWvtbNHaPVewG6SAu8jx/k+0PFTkLNJnbwOFA2qu4DXTzRLwPvAmNd04KcldxJf3EN8S8qbJMoId54CngC/KeqjIl8CTDDgNry0Y4G/gLeQgWy0bjgH8iBwePbbiQyaVBQ8xDV1BLl50ga+BOpZc8YrtLnLmqnDwzPM79wpAhYDcE0i/OgTsxe+i1s/IRmaKkhe1XCAh87s8wS5EU3HBkb6KtxtJvG8n+yrev0hCoIfnVbyiENH/d4LwXx+Ezr4AAAAASUVORK5CYII='"
            width="36"
            height="36"
          /><span
            class="center-name"
            >{{this.$store.state.userName}}
            </span
          >
          <!--../assets/image/user.png-->
          <!-- <span class="center-auth auth-2">未认证</span> -->
        </div>
        <ul class="my-left">
          <li class="m-li1 cur">
            <i class="iconfont icon-wode"></i
            ><router-link to="/teachersPersonalCenter">我的信息</router-link>
          </li>
          <li class="m-li2">
            <i class="iconfont icon-chugui2"></i>
            <router-link to="/personalCenterChangePasswords">修改密码</router-link>
          </li>
          <li class="m-li3">
            <i class="iconfont icon-star-hollow"></i>
            <router-link to="/myCollection">我的收藏</router-link>
          </li>

          <li class="m-li4">
            <i class="iconfont icon-555"></i>

            <router-link to="/myComments">我的评论</router-link>
          </li>

          <li class="m-li8">
            <i class="iconfont icon-555"></i>

            <router-link to="/myExperiment">我的实验</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="pull-right">
      <!--个人信息-->
      <div class="center_content" style="min-height: 476.6px">
        <div class="person clearfix">
          <!--教师-->
          <ul id="elList" v-show="getStatusInformation == 1">
            <li>
              <div class="info">
                用户名：<span>{{ tableData.userName }}</span>
              </div>
            </li>

            <li>
              <div class="info">
                姓名：<span>{{ tableData.nickName }}</span
                ><a href="javascript:;" class="change-email" @click="theNicknamePopup = 1"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>

            <li>
              <div class="info">身份：<span>教师</span></div>
            </li>
            <li>
              <div class="info">
                工号：<span>{{ provincialData.account || "-" }}</span>
              </div>
            </li>
            <li>
              <div class="info">
                性别：<span>{{ gender(tableData.sex)  ||  '-'}}</span>
                <a href="javascript:;" class="change-email" @click="theNicknamePopup = 0"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
            <li>
              <div class="info">
                省市：<span>{{ provincialData.province  ||  '-'}}/{{ provincialData.city  ||  '-'}}</span>
              </div>
            </li>
            <li>
              <div class="info">
                学校：<span>{{ provincialData.school || '-'}}</span>
              </div>
            </li>
            <li>
              <div class="info">
                手机号：<span>{{ hideThePhone(tableData.phonenumber) || '-'}}</span
                ><a class="change-phone" @click="theNicknamePopup = 2"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
          </ul>

          <!--学生-->
          <ul id="elList" v-show="getStatusInformation == 0">
            <li>
              <div class="info">
                用户名：<span>{{ tableData.userName  ||  '-'}}</span>
              </div>
            </li>

            <li>
              <div class="info">
                姓名：<span>{{ tableData.nickName  ||  '-'}}</span
                ><a href="javascript:;" class="change-email" @click="theNicknamePopup = 1"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
            <li>
              <div class="info">身份：<span>学生</span></div>
            </li>

            <li>
              <div class="info">
                性别：<span>{{ gender(tableData.sex)  ||  '-'}}</span>
                <a href="javascript:;" class="change-email" @click="theNicknamePopup = 0"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
            <li>
              <div class="info">
                省市：<span>{{ provincialData.province  ||  '-'}}/{{ provincialData.city  ||  '-'}}</span>
              </div>
            </li>
            <li>
              <div class="info">
                学校：<span>{{ provincialData.school  ||  '-'}}</span>
              </div>
            </li>
            <li>
              <div class="info">
                手机号：<span>{{ hideThePhone(tableData.phonenumber)  ||  '-'}}</span
                ><a class="change-phone" @click="theNicknamePopup = 2"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
          </ul>

          <!--其他-->
          <ul id="elList" v-show="getStatusInformation == 2">
            <li>
              <div class="info">
                用户名：<span>{{ tableData.userName  ||  '-'}}</span>
              </div>
            </li>

            <li>
              <div class="info">
                姓名：<span>{{ tableData.nickName  ||  '-'}}</span
                ><a href="javascript:;" class="change-email" @click="theNicknamePopup = 1"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
            <li>
              <div class="info">身份：<span>其他</span></div>
            </li>

            <li>
              <div class="info">
                性别：<span>{{ gender(tableData.sex)  ||  '-'}}</span>
                <a href="javascript:;" class="change-email" @click="theNicknamePopup = 0"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
            <li>
              <div class="info">
                省市：<span>{{ provincialData.province ||  '-'}}/{{ provincialData.city  ||  '-'}}</span>
              </div>
            </li>
            <li>
              <div class="info">
                行业：<span>{{ provincialData.industry || "-" }}</span>
              </div>
            </li>
            <li>
              <div class="info">
                单位：<span>{{ provincialData.school || "-" }}</span>
              </div>
            </li>
            <li>
              <div class="info">
                手机号：<span>{{ hideThePhone(tableData.phonenumber)  ||  '-' }}</span
                ><a class="change-phone" @click="theNicknamePopup = 2"
                  ><i class="iconfont"></i></a
                >
              </div>
            </li>
          </ul>
          <div class="head">
            <div class="userhead">
              <img :src="imageIsEmpty(tableData.avatar)" />
            </div>
            <div class="upload" id="uploadimg">
              <el-upload
                class="upload-demo"
                action="/dev-api/common/upload"
                multiple
                :data="uploadData"
                :on-success="handleAvatarSuccess"
              >
                编辑
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <!--编辑用户邮箱--><!--<div class="form_overlay" id="form_overlay">--><!-- <div class="form_overlay_bg"></div>--><!-- <div class="form_panel">--><!-- <div class="form_title">编辑邮箱</div>--><!-- <div class="form_content">--><!-- <form id="itemForm">--><!--<div class="item hide">--><!-- <span class="label"><i class="require">*</i>用户名</span>--><!-- <input type="text" class="form-control" name="username" />--><!--</div>--><!-- <div class="item">--><!-- <span class="label"><i class="require"></i>邮箱</span>--><!-- <input type="text" class="form-control" name="email" />--><!-- </div>--><!-- </form>--><!-- </div>--><!-- <div class="form_control">--><!-- <a href="javascript:;" class="button close" id="form_close">取消</a>--><!-- <a href="javascript:;" class="button" id="form_submit">保存</a>--><!-- </div>--><!-- </div>--><!--</div>--><!--编辑用户性别-->
      <div class="form_overlay" v-show="theNicknamePopup == 0">
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">修改性别</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item hide">
                <span class="label"><i class="require">*</i>用户名</span
                ><input
                  type="text"
                  class="form-control"
                  disabled="disabled"
                  name="username"
                />
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>性别</span
                ><!--<select name="gender">--><!-- <option value="">选择性别</option>--><!-- <option value="M">男</option>--><!-- <option value="F">女</option>--><!--</select>-->
                <div class="k-container clearfix">
                  <label class="check-label"
                    ><input
                      type="radio"
                      name="gender"
                      v-model="saveTheParameters.sex"
                      :value="0"
                    />男</label
                  ><label class="check-label"
                    ><input
                      type="radio"
                      name="gender"
                      v-model="saveTheParameters.sex"
                      :value="1"
                    />女</label
                  >
                </div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a href="javascript:;" class="button close" @click="theNicknamePopup = -1"
              >取消</a
            ><a href="javascript:;" class="button" @click="editTheName()">保存</a>
          </div>
        </div>
      </div>
      <!--编辑用户姓名-->
      <div class="form_overlay" v-show="theNicknamePopup == 1">
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">修改姓名</div>
          <div class="form_content">
            <form id="nameForm">
              <div class="item">
                <span class="label"><i class="require">*</i>姓名</span
                ><input
                  type="text"
                  class="form-control"
                  v-model="saveTheParameters.nickName"
                  name="name"
                />
              </div>
              <div class="txt-tip">限2-10个中文汉字</div>
            </form>
          </div>
          <div class="form_control">
            <a href="javascript:;" class="button close" @click="theNicknamePopup = -1"
              >取消</a
            ><a href="javascript:;" class="button" @click="editTheName()">保存</a>
          </div>
        </div>
      </div>

      <!--编辑用户手机号-->
      <div class="form_overlay" v-show="theNicknamePopup == 2">
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">修改手机号</div>
          <div class="form_content">
            <form id="nameForm">
              <div class="item">
                <span class="label"><i class="require">*</i>新手机号</span
                ><input
                  type="text"
                  class="form-control"
                  v-model="saveTheParameters.phonenumber"
                  name="name"
                />
              </div>

              <div class="item">
                <div class="captchaOperation">
                  <div class="verificationCodeOnTheLeftSideOfThe">
                    <span class="label"><i class="require">*</i>验证码</span>
                    <div class="verificationCodeOnTheRightSide">
                      <input
                        type="text"
                        class="form-control"
                        v-model="saveTheParameters.code"
                        name="name"
                      />

                      <div class="sendTheStyle">
                        <el-button
                          type="primary"
                          @click="sendATextMessage(tableData.phonenumber)"
                          :disabled="isDisabled"
                          >{{ buttonName }}</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="item">
                <span class="label"><i class="require">*</i>验证码</span
                ><input
                  type="text"
                  class="verificationCodeStyle"
                  v-model="saveTheParameters.phonenumber"
                  name="name"
                
                />

                <input
                  type="text"
                  class="verificationCodeFormat"
                  v-model="saveTheParameters.phonenumber"
                  name="name"
                
                />
              </div> -->
              <div class="txt-tip">限11位手机号</div>
            </form>
          </div>
          <div class="form_control">
            <a href="javascript:;" class="button close" @click="theNicknamePopup = -1"
              >取消</a
            ><a href="javascript:;" class="button" @click="editTheName()">保存</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  personalInformationQuery,
  afterTheLoginAccessPermissions,
  loginAccessToTheMenu,
  modifyPersonalInformation,
  registeredToSendMessages,
} from "../assets/api/index";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const flag = reactive({
      toDetermineThe: localStorage.getItem("whetherTheLogin"),
    });

    const uploadData = ref({
      uid: null,
    });
    if (flag.toDetermineThe == 1) {
      flag.toDetermineThe = localStorage.setItem("whetherTheLogin", 2);
      setTimeout(function () {
        location.reload();
      }, 500);
    } else {
    }

    if (localStorage.getItem("token")) {
      router.push("/teachersPersonalCenter");
    } else {
      router.push("/registered");
    }

    const theNicknamePopup = ref(-1);
    const tableData = ref([]);
    const theLoginRequest = reactive({
      userId: null,
    });
    const getStatusInformation = ref([]);
    const provincialData = ref([]);
    const getData = () => {
      personalInformationQuery(theLoginRequest).then((res) => {
        tableData.value = res.data;
   localStorage.setItem("headPortrait", res.data.avatar); 

        localStorage.setItem("userName", res.data.userName);
        provincialData.value = JSON.parse(res.data.remark);
        getStatusInformation.value = JSON.parse(res.data.remark).indexType;
        console.log(getStatusInformation.value);
      });
    };

    //登陆后获取权限
    const afterLandingPermissionData = ref();
    const automaticallyAccessPermissions = () => {
      afterTheLoginAccessPermissions().then((res) => {
        afterLandingPermissionData.value = res.user;
        theLoginRequest.userId = res.user.userId;
        let userid = localStorage.setItem("userId", res.user.userId);

        getData();
      });
    };
    automaticallyAccessPermissions();

    //登陆后获取菜单

    const automaticAccessToTheMenu = () => {
      loginAccessToTheMenu().then((res) => {});
    };
    automaticAccessToTheMenu();

    //上传图片
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };

    const gender = (sex) => {
      if (sex == 0) {
        return "男";
      } else {
        return "女";
      }
    };

    //编辑姓名
    const saveTheParameters = reactive({
      userId: localStorage.getItem("userId"),
      userName: localStorage.getItem("userName"),
      sex: 0,
      nickName: null,
      phonenumber: null,
      code: null,
      avatar: null,
    });
    const editTheName = () => {
      modifyPersonalInformation(saveTheParameters).then((res) => {
        if (res.code == 200) {
          ElMessage.success(res.msg);
          theNicknamePopup.value = -1;
          getData();
        } else {
          ElMessage.info(res.msg);
        }
      });
    };
    //发送短信
    const CountDown = ref(120);
    const buttonName = ref("发送验证码");
    const isDisabled = ref(false);
    const sendATextMessage = (value) => {
      registeredToSendMessages(value).then((res) => {
        console.log(value);
        var timer = setTimeout(fn, 1000); //定时
        function fn() {
          CountDown.value--;
          if (CountDown.value > 0) {
            buttonName.value = "请等待 " + CountDown.value + " 秒";
            setTimeout(fn, 1000);
            0;
            isDisabled.value = true;
          } else {
            buttonName.value = "重新获取";
            isDisabled.value = false;
          }
        }

        ElMessage.success("短信发送成功!");
      });

      // if (tableData.phonenumber == null) {
      //   ElMessage.info("请输入手机号");
      // } else {

      // }
    };

    const handleAvatarSuccess = (response, file, fileList) => {
      console.log(2, response.url);
      saveTheParameters.avatar = response.url;
      editTheName();
    };

    //默认图显示
    const imageIsEmpty = (value) => {
      if (value == null || value == "") {
        return require("../assets/image/index.png");
      } else {
        return value;
      }
    };

    //手机号隐藏四位
    const hideThePhone = (value) => {
      const mb = String(value);
      const reg = /^(\d{3})\d{4}(\d{4})$/;
      return mb.replace(reg, "$1****$2");
    };
    return {
      imageIsEmpty,
      handleAvatarSuccess,
      CountDown,
      buttonName,
      isDisabled,
      uploadData,
      hideThePhone,
      sendATextMessage,
      saveTheParameters,
      theNicknamePopup,
      editTheName,
      flag,
      tableData,
      afterLandingPermissionData,
      getStatusInformation,
      provincialData,
      handleRemove,
      gender,
      automaticAccessToTheMenu,
      automaticallyAccessPermissions,
      getData,
    };
  },

  name: "teachersPersonalCenter",
};
</script>

<style src="../assets/css/jiaoshi/bootstrap-v3.3.7.min.css" scoped></style>
<style src="../assets/css/jiaoshi/common.css" scoped></style>
<style src="../assets/css/jiaoshi/common1.css" scoped></style>
<style src="../assets/css/jiaoshi/form.css" scoped></style>
<style src="../assets/css/jiaoshi/laydate.css" scoped></style>
<style src="../assets/css/jiaoshi/my-profile.css" scoped></style>
<style src="../assets/css/jiaoshi/header_v5.css" scoped></style>
<style scoped>
.theEditor {
  background: none;
  border: 0;
  position: relative;
  top: -10px;
}

.verificationCodeStyle {
  width: 46% !important;
}
.verificationCodeFormat {
  width: 18% !important;
}

/*验证码*/

.verificationCodeOnTheLeftSideOfThe {
  display: flex;
}
.verificationCodeOnTheRightSide {
  width: 304px;
  display: flex;
}
.form-control {
  flex: 1;
  width: 50px;
}

.sendTheStyle {
  height: 32px;
  display: flex;
  line-height: 5px;
  color: #fff;
}
</style>